import { ceData } from 'components/CeData';

export default function useTranslation() {
  const i18n = ceData.context?.msg;
  return {
    i18n,
    t: (key, params) => (i18n ? i18n.t(key, params) : key),
  };
}
